"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.moveCameraByOffset = exports.getCursorWorldPosition = exports.getCursorPhysicsPosition = exports.setCameraXY = exports.getCameraXY = exports.uiToWorld = exports.worldToPhysics = exports.physicsToWorld = void 0;
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var crokinoleDefs_sidecar_1 = require("./crokinoleDefs-sidecar");
var cOx = 0;
var cOy = 0;
var physicsToWorld = function (px, py) {
    var physicsScale = crokinoleDefs_sidecar_1.crokinoleDefs.physicsScale;
    var cam = voyageCamera_sidecar_1.voyageCamera.get();
    return {
        x: px * physicsScale - cam.cameraX + cOx,
        y: py * -physicsScale - cam.cameraY + cOy,
    };
};
exports.physicsToWorld = physicsToWorld;
var worldToPhysics = function (wx, wy) {
    var physicsScale = crokinoleDefs_sidecar_1.crokinoleDefs.physicsScale;
    var cam = voyageCamera_sidecar_1.voyageCamera.get();
    return {
        x: (wx - cOx + cam.cameraX) / physicsScale,
        y: (wy - cOy + cam.cameraY) / -physicsScale,
    };
};
exports.worldToPhysics = worldToPhysics;
var uiToWorld = function (ux, uy) {
    var cam = voyageCamera_sidecar_1.voyageCamera.get();
    return {
        x: ux + cam.cameraX + cOx,
        y: uy + cam.cameraY + cOy,
    };
};
exports.uiToWorld = uiToWorld;
var getCameraXY = function () {
    var cam = voyageCamera_sidecar_1.voyageCamera.get();
    return { cx: cam.cameraX, cy: cam.cameraY };
};
exports.getCameraXY = getCameraXY;
var setCameraXY = function (cx, cy) {
    voyageCamera_sidecar_1.voyageCamera.setCameraXY(cx, cy);
};
exports.setCameraXY = setCameraXY;
var getCursorPhysicsPosition = function () {
    var cursor = voyageCamera_sidecar_1.voyageCamera.getUiMousePosition();
    var physicsCursor = exports.worldToPhysics(cursor.mx, cursor.my);
    return physicsCursor;
};
exports.getCursorPhysicsPosition = getCursorPhysicsPosition;
var getCursorWorldPosition = function () {
    var cursor = voyageCamera_sidecar_1.voyageCamera.getUiMousePosition();
    var physicsCursor = exports.uiToWorld(cursor.mx, cursor.my);
    return physicsCursor;
};
exports.getCursorWorldPosition = getCursorWorldPosition;
var moveCameraByOffset = function (x, y) {
    //let { physicsScale } = crokinoleDefs
    var cam = voyageCamera_sidecar_1.voyageCamera.get();
    //cam.cameraX += x //* physicsScale
    //cam.cameraY += y //* physicsScale
    voyageCamera_sidecar_1.voyageCamera.setCameraXY(cam.cameraX + x, cam.cameraY + y);
    //voyageCamera.constrainToBounds()
};
exports.moveCameraByOffset = moveCameraByOffset;
